import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Count active mutations (non-GET) to drive the "saving..." indicator.
  const method = (config.method || "get").toLowerCase();
  if (method !== "get") {
    api._savingCount = (api._savingCount || 0) + 1;
    window.dispatchEvent(new CustomEvent("crescendo:save-state", { detail: { saving: true } }));
  }
  return config;
});

const onFinish = (config) => {
  const method = ((config?.method) || "get").toLowerCase();
  if (method !== "get") {
    api._savingCount = Math.max(0, (api._savingCount || 1) - 1);
    // Don't count auto-snapshot POSTs as user mutations — otherwise each
    // snapshot would feed the counter for the next one (issue #8).
    const url = config?.url || "";
    const isSnapshot = /\/snapshots\b/.test(url);
    window.dispatchEvent(new CustomEvent("crescendo:save-state", {
      detail: {
        saving: api._savingCount > 0,
        at: api._savingCount === 0 ? new Date().toISOString() : null,
        kind: api._savingCount === 0 && !isSnapshot ? "mutation" : undefined,
      },
    }));
  }
};
api.interceptors.response.use(
  (res) => { onFinish(res.config); return res; },
  (err) => {
    onFinish(err.config);
    // Expired / invalid token — clear it and go to login
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    if (err?.response?.status === 402) {
      window.dispatchEvent(new CustomEvent("crescendo:paywall", {
        detail: err.response.data?.detail || { message: "Upgrade required" },
      }));
    }
    return Promise.reject(err);
  },
);

export const NODE_TYPE_COLORS = {
  task: "#EF4444",
  routine: "#FFCC00",
  action: "#0055FF",
  reminder: "#00C781",
  trigger: "#FF8A00",
  condition: "#A855F7",
  note: "#A1A1AA",
  sequence: "#14B8A6",
  resource: "#6366F1",
};

export const NODE_TYPES = ["task", "routine", "reminder", "trigger", "action", "condition", "sequence", "note", "resource", "buffer"];

// OS detection for OS-aware keybinds. Evaluated once at module load.
export const IS_MAC = typeof navigator !== "undefined" &&
  (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || /Mac/i.test(navigator.userAgent || ""));
export const MOD_KEY = IS_MAC ? "⌘" : "Ctrl";

